import http from "../../services/http";

const getAllReleaseFormsApi = async (id) => {
  return await http("get", `v1/formularios_colaboradores/formularios_lancamento/getAll/${id}`);
};

const getReportByScoreApi = async (id) => {
  return await http("get", `v1/formularios_colaboradores/formularios_lancamento/getReportByScore/${id}`);
};

const getReportApi = async (id) => {
  return await http("get", `v1/formularios_colaboradores/formularios_lancamento/getReport/${id}`);
};

const createReleaseFormApi = async (data) => {
  return await http("post", "v1/formularios_colaboradores/formularios_lancamento/create", data);
};

const deleteReleaseFormApi = async (id) => {
  return await http("post", "v1/formularios_colaboradores/formularios_lancamento/delete", { id: id });
};

const getAllPendingByCollaboratorIdApi = async () => {
  return await http("get", `v1/formularios_colaboradores/formularios_lancamento/getAllPendingByCollaboratorId`);
};

const releaseFormApi = async (data) => {
  return await http("post", "v1/formularios_colaboradores/formularios_lancamento/release", data);
};

const getReleaseFormApi = async (id) => {
  return await http("get", `v1/formularios_colaboradores/formularios_lancamento/getReleaseForm/${id}`);
};

export {
  getAllReleaseFormsApi,
  createReleaseFormApi,
  deleteReleaseFormApi,
  getAllPendingByCollaboratorIdApi,
  getReleaseFormApi,
  releaseFormApi,
  getReportByScoreApi,
  getReportApi,
};
